import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">Urban Biometeorology</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-health/urban-health.png'} alt={'urban health'} size={'medium'} center mdxType="Image" />
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-health/UCM-Human coupling.png'} alt={'urban health'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p>{`Huang X, Chang JMH, Shi D, Chan PW, `}<strong parentName="p">{`Song J`}</strong>{` (2025), `}<Link href={'https://doi: 10.1016/j.buildenv.2024.112191'} mdxType="Link">{`WRF-HEATS coupling: Incorporating human behaviors and city topography into urban heat stress evaluation, `}<em parentName="p">{`Building and Environment`}</em>{`, 267(B), 112191.`}</Link></p>
      <p>{`Zhong Q, `}<strong parentName="p">{`Song J`}</strong>{`, Shi D, Dung C-H (2023). `}<Link href={'https://doi: 10.1016/j.buildenv.2023.110840'} mdxType="Link">{`Protective facemask-induced facial thermal stress and breathing burden during exercise in gyms. `}<em parentName="p">{`Building and Environment`}</em>{`, 244, 110840.`}</Link></p>
      <p>{`Huang X, `}<strong parentName="p">{`Song J*`}</strong>{`, Wang C, Chan PW (2022). `}<Link href={'https://www.sciencedirect.com/science/article/pii/S1364032122008000'} mdxType="Link">{`Realistic representation of city street-level human thermal stress via a new urban climate-human coupling system. `}<em parentName="p">{`Renewable and Sustainable Energy Reviews`}</em>{`, 169, 112919.`}</Link></p>
      <p>{`Shi D, `}<strong parentName="p">{`Song J*`}</strong>{`, Du R, Chan PW (2021). `}<Link href={'https://www.sciencedirect.com/science/article/pii/S0360132321007150'} mdxType="Link">{`Dual challenges of heat wave and protective facemask-induced thermal stress in Hong Kong. `}<em parentName="p">{`Building and Environment`}</em>{`, 206, 108317.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      